import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "mb-1 text-muted f12px" }
const _hoisted_6 = { class: "col-md-12 div-table-boletos box-table table-responsive" }
const _hoisted_7 = { class: "table table-striped table-hover table-bordered table-sm" }
const _hoisted_8 = { class: "th-fixed" }
const _hoisted_9 = { class: "form-check" }
const _hoisted_10 = { class: "col-md-12 text-center table-danger" }
const _hoisted_11 = {
  colspan: "15",
  class: "text-center"
}
const _hoisted_12 = { class: "d-inline" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "text-start",
  "data-label": "Pedido"
}
const _hoisted_15 = { class: "form-check" }
const _hoisted_16 = ["id", "onUpdate:modelValue"]
const _hoisted_17 = ["for"]
const _hoisted_18 = {
  key: 1,
  class: "text-start",
  "data-label": "Banco"
}
const _hoisted_19 = {
  key: 2,
  class: "text-center",
  "data-label": "Dt Documento"
}
const _hoisted_20 = {
  key: 3,
  class: "text-center",
  "data-label": "Dt. Vencto"
}
const _hoisted_21 = {
  key: 4,
  class: "text-start",
  "data-label": "Nosso Número"
}
const _hoisted_22 = {
  key: 5,
  class: "text-start",
  "data-label": "Docto Origem"
}
const _hoisted_23 = {
  key: 6,
  class: "text-start nowrap-celular",
  "data-label": "Razão Social"
}
const _hoisted_24 = {
  key: 7,
  class: "text-end",
  "data-label": "Valor R$"
}
const _hoisted_25 = {
  key: 8,
  class: "",
  "data-label": "Tipo Ocorrência"
}
const _hoisted_26 = {
  class: "text-start",
  "data-label": "Status"
}
const _hoisted_27 = {
  class: "text-center text-nowrap",
  "data-label": "Opções"
}
const _hoisted_28 = { class: "opcoes" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "btn-group" }
const _hoisted_32 = { class: "dropdown-menu" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "card-footer" }
const _hoisted_43 = { class: "d-flex flex-wrap align-items-center gap-1 mb-2" }
const _hoisted_44 = { class: "dropup" }
const _hoisted_45 = { class: "dropdown-menu" }
const _hoisted_46 = { class: "d-flex flex-wrap align-items-center justify-content-between gap-2" }
const _hoisted_47 = { class: "small" }
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-md-12" }
const _hoisted_50 = ["id", "onUpdate:modelValue"]
const _hoisted_51 = ["for"]
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "fw-bold border-bottom mb-1" }
const _hoisted_54 = { class: "col-5 text-muted" }
const _hoisted_55 = { class: "col-7 text-break" }
const _hoisted_56 = { class: "table-responsive" }
const _hoisted_57 = { class: "table table-sm table-striped table-bordered small mb-1" }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { class: "text-nowrap" }
const _hoisted_60 = { class: "text-end" }
const _hoisted_61 = { class: "text-nowrap" }
const _hoisted_62 = { class: "text-center" }
const _hoisted_63 = { class: "text-danger fw-bold" }

import { onMounted, reactive, } from "vue";
import config from "@/app.config.json";

//servicos
import * as service from "@/services/BoletosService";
import { addDays, fdata, f2dec, fdataUS, fdataUSS, fdataHora, salvarFiltros, carregarFiltros } from "@/utils/funcoes";

//componentes
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import Pesquisa from "./Pesquisa.vue";
import Loading from "@/components/Loading/index.vue";
import MsgBox from "@/components/MsgBox/Index.vue";
import Paginador from "@/components/Paginador/Index.vue";

//janelas
import GerarBoletos from "./GerarBoletos.vue"
import GerarRemessa from "./GerarRemessa.vue"
import ImportarRetorno from "./ImportarRetorno.vue"

import { RouterLink } from "vue-router";

interface configColuna {
    coluna: string,
    exibe: boolean
}

interface BoletoDto extends service.Boleto {
    marcado: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {


//vue
var controle = reactive({
    filtros: {
        paginaAtual: 1,
        tamanhoPagina: 1000
    } as service.BoletoFiltros,
    boletos: [] as BoletoDto[],
    boletosRemessa: [] as BoletoDto[],
    boletoId: 0 as number,
    boleto: {} as service.Boleto,
    ordemDirecao: "Desc",
    ordemColuna: "BoletoId",
    totalRegistros: 0,
    marcarTodos: false,
    totais: {
        qtde: 0,
        total: 0,
    },
    colunas: [
        { coluna: "Id", exibe: true },
        { coluna: "Banco", exibe: false },
        { coluna: "Nosso Número", exibe: true },
        { coluna: "Docto Origem", exibe: true },
        { coluna: "Dt Documento", exibe: true },
        { coluna: "Dt. Vencto", exibe: true },
        { coluna: "Cliente", exibe: true },
        { coluna: "Razão social", exibe: true },
        { coluna: "Valor R$", exibe: true },
        { coluna: "Tipo Ocorrência", exibe: true },
        { coluna: "Usuário", exibe: true },
        { coluna: "Sequencial", exibe: true },
        { coluna: "Status", exibe: true },
    ] as configColuna[],

    janColunas: false,
    janDetalhes: false,
    historico: [] as service.BoletoHistoricoDTO[],
    statusHistorico: "",
    erroHistorico: "",

    janGerarBoletos: false,
    janGerarRemessa: false,
    janImportarRetorno: false,

    pesquisando: false,
    loading: false,
    status: "",
    erro: "",

});



onMounted(() => {
    carregarConfig();
})

function salvarConfig() {
    salvarFiltros("boletosColunas", controle.colunas);
    salvarFiltros("boletosFiltros", controle.filtros)
}

function carregarConfig() {
    var colunas = carregarFiltros("boletosColunas") as configColuna[];

    //mescla com a config salva, mantendo o padrao das colunas novas que ainda nao foram salvas
    if (colunas != null) {
        controle.colunas.forEach((padrao) => {
            var salvo = colunas.find(a => a.coluna == padrao.coluna);
            if (salvo != undefined)
                padrao.exibe = salvo.exibe;
        });
    }

    //a coluna Banco passou a ficar oculta por padrao
    var banco = controle.colunas.find(a => a.coluna == "Banco");
    if (banco != undefined)
        banco.exibe = false;

    var filtros2 = carregarFiltros("boletosFiltros");

}

const pesquisar = async (maisFiltros?: any) => {

    controle.erro = "";
    controle.pesquisando = true;
    controle.status = "Pesquisando...";
    controle.boletos = [] as BoletoDto[];

    if (maisFiltros != undefined) {
        controle.filtros.nome = maisFiltros.nome;

        console.log("maisFiltros: ", maisFiltros);

        if (maisFiltros.dataCadIni != null && maisFiltros.dataCadIni != "")
            controle.filtros.dataCadIni = fdataUSS(maisFiltros.dataCadIni);
        else
            controle.filtros.dataCadIni = undefined;

        if (maisFiltros.dataCadFim != null && maisFiltros.dataCadFim != "")
            controle.filtros.dataCadFim = fdataUSS(maisFiltros.dataCadFim);
        else
            controle.filtros.dataCadFim = undefined;

        if (maisFiltros.dataDocIni != null && maisFiltros.dataDocIni != "")
            controle.filtros.dataDocIni = fdataUSS(maisFiltros.dataDocIni);
        else
            controle.filtros.dataDocIni = undefined;

        if (maisFiltros.dataDocFim != null && maisFiltros.dataDocFim != "")
            controle.filtros.dataDocFim = fdataUSS(maisFiltros.dataDocFim);
        else
            controle.filtros.dataDocFim = undefined;

        if (maisFiltros.dataVencIni != null && maisFiltros.dataVencIni != "")
            controle.filtros.dataVencIni = fdataUSS(maisFiltros.dataVencIni);
        else
            controle.filtros.dataVencIni = undefined;

        if (maisFiltros.dataVencFim != null && maisFiltros.dataVencFim != "")
            controle.filtros.dataVencFim = fdataUSS(maisFiltros.dataVencFim);
        else
            controle.filtros.dataVencFim = undefined;

        if (maisFiltros.nossoNumero != null && maisFiltros.nossoNumero != "")
            controle.filtros.nossoNumero = maisFiltros.nossoNumero;
        else
            controle.filtros.nossoNumero = undefined;

        if (maisFiltros.numeroDocumento != null && maisFiltros.numeroDocumento != "")
            controle.filtros.numeroDocumento = maisFiltros.numeroDocumento;
        else
            controle.filtros.numeroDocumento = undefined;

        if (maisFiltros.statusId != null && maisFiltros.statusId != "")
            controle.filtros.statusId = maisFiltros.statusId;
        else
            controle.filtros.statusId = undefined;
    }

    service.obter(controle.filtros)
        .then((r) => {
            controle.pesquisando = false;
            controle.status = "";
            controle.boletos = r.dados as BoletoDto[];
            controle.totalRegistros = r.totalRegistros;

            controle.totais.total = 0;

            controle.boletos.forEach((boleto) => {

                controle.totais.qtde++;

                controle.totais.total += (boleto.valorDocumento ?? 0);


                //marca os boletos que estavam marcados
                // var marcado = controle.marcados.find(a => a.boletoId == boleto.boletoId);
                // if (marcado != undefined && marcado != null) {
                //     console.log("marcado: ", marcado);
                //     boleto.marcado = true;
                // }
            });

            salvarConfig();
        })
        .catch((erro: string) => {
            controle.pesquisando = false;
            controle.erro = erro;
            controle.status = "Erro: " + erro + "<br> Tente novamente mais tarde";
        });
};

function exibeCol(coluna: string) {
    var d = controle.colunas.find(a => a.coluna == coluna);
    return (d != undefined && d.exibe == true);
}

const ordenarPor = (coluna: string) => {
    if (controle.ordemColuna == coluna) {
        if (controle.ordemDirecao == "asc")
            controle.ordemDirecao = "desc";
        else
            controle.ordemDirecao = "asc";
    }
    else
        controle.ordemDirecao = "asc";

    controle.ordemColuna = coluna;

    if (controle.ordemDirecao == "asc")
        controle.boletos = controle.boletos.sort((a, b) => (a[coluna] > b[coluna]) ? 1 : ((b[coluna] > a[coluna]) ? -1 : 0));
    else
        controle.boletos = controle.boletos.sort((a, b) => (a[coluna] < b[coluna]) ? 1 : ((b[coluna] < a[coluna]) ? -1 : 0));
}

function exibirDetalhes(boleto: service.Boleto) {
    controle.boleto = boleto;
    controle.boletoId = boleto.boletoId ?? 0;
    controle.historico = [];
    controle.erroHistorico = "";
    controle.statusHistorico = "Buscando remessas e retornos...";
    controle.janDetalhes = true;

    service.obterHistorico(boleto.boletoId)
        .then((r) => {
            controle.historico = r;
            controle.statusHistorico = "";
        })
        .catch((erro) => {
            controle.erroHistorico = `Erro ao buscar remessas e retornos: ${erro.message || erro}`;
            controle.statusHistorico = "";
        });
}

function dataOuTraco(v: string | null | undefined) {
    return !v || v.startsWith("0001") ? "-" : (fdata(v) ?? "-");
}

function secoesDetalhes(b: service.Boleto) {
    const dt = dataOuTraco;
    const vlr = (v: number | null | undefined) => (v ? `R$ ${f2dec(v)}` : "-");
    const txt = (v: unknown) => (v === null || v === undefined || v === "" ? "-" : String(v));

    return [
        {
            titulo: "Boleto", campos: [
                ["Id", txt(b.boletoId)], ["Status", txt(b.status?.descricao)], ["Cliente", txt(b.clienteId)],
                ["Contrato", txt(b.contratoId)], ["Docto origem", txt(b.numeroDocumento)], ["Parcela", `${txt(b.parcela)} / ${txt(b.totalParcelas)}`],
                ["Nosso número", txt(b.nossoNumero)], ["Seu número", txt(b.seuNumero)], ["Carteira", txt(b.carteira)],
                ["Espécie", `${txt(b.especie)} ${txt(b.especieMod)}`], ["Aceite", b.aceite ? "Sim" : "Não"],
                ["Ocorrência", b.ocorrencia ? `${b.ocorrenciaId} - ${b.ocorrencia.descricao}` : txt(b.ocorrenciaId)],
            ]
        },
        {
            titulo: "Banco", campos: [
                ["Banco", txt(b.banco)], ["Agência", txt(b.agencia)], ["Posto", txt(b.posto)], ["Conta", txt(b.conta)],
            ]
        },
        {
            titulo: "Valores e datas", campos: [
                ["Valor", vlr(b.valorDocumento)], ["Dt documento", dt(b.dataDocumento)], ["Dt vencimento", dt(b.dataVencimento)],
                ["Dt processamento", dt(b.dataProcessamento)], ["Dt baixa", dt(b.dataBaixa)], ["Dt limite pagto", dt(b.dataLimitePagto)],
                ["Desconto", vlr(b.vlrDesconto)], ["Dt desconto", dt(b.dataDesconto)], ["Abatimento", vlr(b.valorAbatimento)],
                ["Dt abatimento", dt(b.dataAbatimento)], ["Mora/juros", vlr(b.valorMoraJuros)], ["Dt mora/juros", dt(b.dataMoraJuros)],
                ["Multa %", txt(b.percMulta || null)], ["Dt multa", dt(b.dataMulta)], ["IOF", vlr(b.valorIOF)],
                ["Outras despesas", vlr(b.valorOutrasDespesas)], ["Dias protesto", txt(b.diasDeProtesto || null)],
                ["Dt protesto", dt(b.dataProtesto)], ["Dias negativação", txt(b.diasDeNegativacao)], ["Dt negativação", dt(b.dataNegativacao)],
            ]
        },
        {
            titulo: "Sacado", campos: [
                ["Nome", txt(b.sacadoNome)], ["CPF/CNPJ", txt(b.sacadoCpfCnpj)], ["E-mail", txt(b.sacadoEmail)],
                ["Endereço", `${txt(b.sacadoLogradouro)}, ${txt(b.sacadoNumero)} ${b.sacadoComplemento ?? ""}`], ["Bairro", txt(b.sacadoBairro)],
                ["Cidade/UF", `${txt(b.sacadoCidade)} / ${txt(b.sacadoUF)}`], ["CEP", txt(b.sacadoCep)],
            ]
        },
        {
            titulo: "Mensagens e pagamento", campos: [
                ["Instrução 1", txt(b.instrucao1)], ["Instrução 2", txt(b.instrucao2)], ["Mensagem", txt(b.mensagemLinhas)],
                ["Linha digitável", txt(b.linhaDigitavel)], ["Código de barras", txt(b.codigoBarras)], ["PIX (EMV)", txt(b.emv)],
            ]
        },
    ];
}

function imprimir(boleto: service.Boleto) {
    if (boleto.boletoId == null || boleto.boletoId == 0) {
        controle.erro = "Boleto inválido";
        return;
    }

    const urlBase = `${config.urlApi}`

    var url = `${urlBase}/Boletos/Ver/${boleto.boletoId}`;

    window.open(url, '_blank');
}

function marcarTodos() {

    controle.boletos.forEach(item => {
        item.marcado = controle.marcarTodos;
    });

    salvarConfig();
}



function atualizarPixSelecionados() {

    const ids = controle.boletos.filter(a => a.marcado == true).map(a => a.boletoId);

    if (ids.length == 0) {
        controle.erro = "Selecione ao menos um boleto para atualizar o PIX.";
        return;
    }

    controle.status = `Atualizando PIX de ${ids.length} boleto(s)...`;
    controle.loading = true;

    service.atualizarPixBoletos(ids)
        .then((r) => {
            const sucesso = r.filter(a => a.sucesso && a.temPix).length;
            const semPix = r.filter(a => a.sucesso && !a.temPix).length;
            const falhas = r.filter(a => !a.sucesso).length;

            controle.status = `PIX atualizado: ${sucesso} com PIX, ${semPix} sem PIX, ${falhas} com erro.`;

            pesquisar();

            setTimeout(() => {
                controle.loading = false;
                controle.status = "";
            }, 5000);
        })
        .catch((erro: string) => {
            controle.erro = "Erro ao atualizar PIX: " + erro;
            controle.loading = false;
        });
}

function consultarNoBanco(boleto: service.Boleto) {

    controle.status = "Consultando no banco...";
    controle.loading = true;
    service.consultarBoletoBanco(boleto.boletoId)
        .then(() => {

            controle.status = "Consulta realizada com sucesso.";

            setTimeout(() => {
                pesquisar();
                controle.loading = false;
                controle.status = "";
            }, 3000);
        })
        .catch((erro: string) => {
            controle.status = "Erro ao gravar ocorrência: " + erro;
            setTimeout(() => {
                controle.loading = false;
                controle.status = "";
            }, 4000);
        });
}

function novaOcorrencia(boleto: service.Boleto, ocorrenciaId: string) {

    controle.status = "Gravando ocorrência...";
    controle.loading = true;
    service.novaOcorrencia({ boletoId: boleto.boletoId, ocorrenciaId: ocorrenciaId } as service.RemessaSolicitarDTO)
        .then(() => {

            controle.status = "Ocorrência gravada com sucesso.";

            setTimeout(() => {
                pesquisar();
                controle.loading = false;
                controle.status = "";
            }, 3000);
        })
        .catch((erro: string) => {
            controle.status = "Erro ao gravar ocorrência: " + erro;
            setTimeout(() => {
                controle.loading = false;
                controle.status = "";
            }, 4000);
        });
}

function cancelar(boleto: service.Boleto) {

    controle.status = "Cancelando boleto...";
    controle.loading = true;
    service.cancelarBoleto(boleto.boletoId)
        .then(() => {

            controle.status = "Boleto cancelado com sucesso.";

            setTimeout(() => {
                pesquisar();
                controle.loading = false;
                controle.status = "";
            }, 3000);
        })
        .catch((erro: string) => {
            controle.status = "Erro ao cancelar boleto: " + erro;
            setTimeout(() => {
                controle.loading = false;
                controle.status = "";
            }, 4000);
        });
}

function registrarBoleto(boleto: service.Boleto) {

    controle.status = "Registrando boleto...";

    controle.loading = true;

    service.registrarBoleto({ boletoId: boleto.boletoId } as service.FiltroBoleto)
        .then(() => {

            controle.status = "Boleto registrado com sucesso.";

            setTimeout(() => {
                pesquisar();
                controle.loading = false;
                controle.status = "";
            }, 3000);
        })
        .catch((erro: string) => {
            controle.status = "Erro ao registrar boleto: " + erro;
            setTimeout(() => {
                controle.loading = false;
                controle.status = "";
            }, 4000);
        });
}

function gerarRemessa() {
    console.log("Gerar remessa");
    controle.boletosRemessa = controle.boletos.filter(a => a.marcado == true);
    controle.janGerarRemessa = true;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Loading, {
      isLoading: _unref(controle).loading,
      mensagem: _unref(controle).status
    }, null, 8, ["isLoading", "mensagem"]),
    _createVNode(BreadCrumb, {
      PageTitle: "Manutenção de boletos",
      items: [{label: 'Inicio', to: '/'}]
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(Pesquisa, { onOnPesquisar: pesquisar })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, "Total: " + _toDisplayString(_unref(controle).totalRegistros) + " registro(s)", 1),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _createElementVNode("thead", _hoisted_8, [
              _createElementVNode("tr", null, [
                (exibeCol('Id'))
                  ? (_openBlock(), _createElementBlock("th", {
                      key: 0,
                      class: "text-start",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (ordenarPor('Pedido')))
                    }, [
                      _createElementVNode("div", _hoisted_9, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          id: `chkMarcarTodos`,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).marcarTodos) = $event)),
                          onChange: marcarTodos
                        }, null, 544), [
                          [_vModelCheckbox, _unref(controle).marcarTodos]
                        ]),
                        _cache[29] || (_cache[29] = _createElementVNode("label", {
                          class: "form-check-label",
                          for: `chkMarcarTodos`
                        }, " Id ", -1))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (exibeCol('Banco'))
                  ? (_openBlock(), _createElementBlock("th", {
                      key: 1,
                      class: "text-start",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (ordenarPor('dataPedido')))
                    }, "Banco"))
                  : _createCommentVNode("", true),
                (exibeCol('Dt Documento'))
                  ? (_openBlock(), _createElementBlock("th", {
                      key: 2,
                      class: "text-center",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (ordenarPor('dataDocumento')))
                    }, " Dt Documento "))
                  : _createCommentVNode("", true),
                (exibeCol('Dt. Vencto'))
                  ? (_openBlock(), _createElementBlock("th", {
                      key: 3,
                      class: "text-center",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (ordenarPor('vendedorNome')))
                    }, " Dt. Vencto "))
                  : _createCommentVNode("", true),
                (exibeCol('Nosso Número'))
                  ? (_openBlock(), _createElementBlock("th", {
                      key: 4,
                      class: "text-start",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (ordenarPor('clienteId')))
                    }, " Nosso Número"))
                  : _createCommentVNode("", true),
                (exibeCol('Docto Origem'))
                  ? (_openBlock(), _createElementBlock("th", {
                      key: 5,
                      class: "text-start",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (ordenarPor('clienteRazao')))
                    }, " Docto"))
                  : _createCommentVNode("", true),
                (exibeCol('Razão social'))
                  ? (_openBlock(), _createElementBlock("th", {
                      key: 6,
                      class: "text-start",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (ordenarPor('tipoDescricao')))
                    }, " Razão social"))
                  : _createCommentVNode("", true),
                (exibeCol('Valor R$'))
                  ? (_openBlock(), _createElementBlock("th", {
                      key: 7,
                      class: "text-end",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (ordenarPor('nomeCidade')))
                    }, "Valor R$ "))
                  : _createCommentVNode("", true),
                (exibeCol('Tipo Ocorrência'))
                  ? (_openBlock(), _createElementBlock("th", {
                      key: 8,
                      class: "text-start",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (ordenarPor('transpNome')))
                    }, " Tipo"))
                  : _createCommentVNode("", true),
                (exibeCol('Status'))
                  ? (_openBlock(), _createElementBlock("th", {
                      key: 9,
                      class: "text-start",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (ordenarPor('statusId')))
                    }, "Status"))
                  : _createCommentVNode("", true),
                _cache[30] || (_cache[30] = _createElementVNode("th", { class: "text-center" }, "Opções", -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              _withDirectives(_createElementVNode("tr", null, [...(_cache[31] || (_cache[31] = [
                _createElementVNode("td", {
                  colspan: "15",
                  class: "text-center"
                }, [
                  _createElementVNode("div", { class: "d-inline" }, [
                    _createElementVNode("i", { class: "fa fa-cog fa-spin" }),
                    _createTextVNode(" Pesquisando... ")
                  ])
                ], -1)
              ]))], 512), [
                [_vShow, _unref(controle).pesquisando == true]
              ]),
              _withDirectives(_createElementVNode("tr", _hoisted_10, [
                _createElementVNode("td", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _cache[32] || (_cache[32] = _createElementVNode("i", { class: "fa fa-exclamation" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_unref(controle).erro), 1)
                  ]),
                  _createElementVNode("a", {
                    class: "btn btn-primary btn-sm",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (pesquisar()))
                  }, "Repetir")
                ])
              ], 512), [
                [_vShow, _unref(controle).erro != '']
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).boletos, (item, idx) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: idx,
                  class: _normalizeClass(item.marcado == true ? 'table-active' : ''),
                  onClick: ($event: any) => {_unref(controle).boletoId = item.boletoId; _unref(controle).boleto = item}
                }, [
                  (exibeCol('Id'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            id: `chkped-${item.boletoId}`,
                            "onUpdate:modelValue": ($event: any) => ((item.marcado) = $event)
                          }, null, 8, _hoisted_16), [
                            [_vModelCheckbox, item.marcado]
                          ]),
                          _createElementVNode("label", {
                            class: "form-check-label",
                            for: `chkped-${item.boletoId}`
                          }, _toDisplayString(item.boletoId), 9, _hoisted_17)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (exibeCol('Banco'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString(item.banco), 1))
                    : _createCommentVNode("", true),
                  (exibeCol('Dt Documento'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_19, _toDisplayString(_unref(fdata)(item.dataDocumento)), 1))
                    : _createCommentVNode("", true),
                  (exibeCol('Dt. Vencto'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_20, _toDisplayString(_unref(fdata)(item.dataVencimento)), 1))
                    : _createCommentVNode("", true),
                  (exibeCol('Nosso Número'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(item.nossoNumero), 1))
                    : _createCommentVNode("", true),
                  (exibeCol('Docto Origem'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_22, _toDisplayString(item.numeroDocumento), 1))
                    : _createCommentVNode("", true),
                  (exibeCol('Razão social'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_23, _toDisplayString(item.sacadoNome), 1))
                    : _createCommentVNode("", true),
                  (exibeCol('Valor R$'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_24, " R$ " + _toDisplayString(_unref(f2dec)(item.valorDocumento)), 1))
                    : _createCommentVNode("", true),
                  (exibeCol('Tipo Ocorrência'))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_25, _toDisplayString(item.ocorrenciaId) + " - " + _toDisplayString(item.ocorrencia.descricao), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", _hoisted_26, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["badge", item.status?.classeCor])
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(item.status?.classeIcone)
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(item.status?.descricao), 1)
                    ], 2)
                  ]),
                  _createElementVNode("td", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("a", {
                        class: "btn btn-sm btn-info me-1",
                        href: "javascript:void(0)",
                        onClick: ($event: any) => (exibirDetalhes(item)),
                        title: "Ver todos os dados do boleto, remessas e retornos"
                      }, [...(_cache[33] || (_cache[33] = [
                        _createElementVNode("i", { class: "fa fa-search" }, null, -1)
                      ]))], 8, _hoisted_29),
                      (item.status?.podeImprimir)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "btn btn-sm btn-warning me-1",
                            title: "Imprimir Boleto",
                            href: "javascript:void(0)",
                            onClick: ($event: any) => (imprimir(item))
                          }, [...(_cache[34] || (_cache[34] = [
                            _createElementVNode("i", { class: "fa fa-print" }, null, -1)
                          ]))], 8, _hoisted_30))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_31, [
                        _cache[44] || (_cache[44] = _createElementVNode("a", {
                          class: "dropdown-toggle btn btn-sm btn-primary",
                          href: "#",
                          role: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          _createElementVNode("i", { class: "flaticon-more" })
                        ], -1)),
                        _createElementVNode("ul", _hoisted_32, [
                          _createElementVNode("li", null, [
                            (item.status?.podeImprimir)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "dropdown-item",
                                  href: "javascript:void(0)",
                                  onClick: ($event: any) => (imprimir(item))
                                }, [...(_cache[35] || (_cache[35] = [
                                  _createElementVNode("i", { class: "fa fa-print" }, null, -1),
                                  _createTextVNode(" Imprimir ", -1)
                                ]))], 8, _hoisted_33))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("li", null, [
                            (item.statusId == 1)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "dropdown-item",
                                  href: "javascript:void(0)",
                                  onClick: ($event: any) => (cancelar(item))
                                }, [...(_cache[36] || (_cache[36] = [
                                  _createElementVNode("i", { class: "fa fa-ban" }, null, -1),
                                  _createTextVNode(" Cancelar ", -1)
                                ]))], 8, _hoisted_34))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("li", null, [
                            (item.status?.podeBaixar)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "dropdown-item",
                                  href: "javascript:void(0)",
                                  onClick: ($event: any) => (novaOcorrencia(item, '1'))
                                }, [...(_cache[37] || (_cache[37] = [
                                  _createElementVNode("i", { class: "fa fa-download" }, null, -1),
                                  _createTextVNode(" Pedido de baixa ", -1)
                                ]))], 8, _hoisted_35))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("li", null, [
                            (item.status?.podeRemessa)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "dropdown-item",
                                  href: "javascript:void(0)",
                                  onClick: ($event: any) => (registrarBoleto(item, '1'))
                                }, [...(_cache[38] || (_cache[38] = [
                                  _createElementVNode("i", { class: "fa fa-file-alt" }, null, -1),
                                  _createTextVNode(" Registrar Boleto Online ", -1)
                                ]))], 8, _hoisted_36))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("li", null, [
                            (item.status?.podeBaixar)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "dropdown-item",
                                  href: "javascript:void(0)",
                                  onClick: ($event: any) => (consultarNoBanco(item))
                                }, [...(_cache[39] || (_cache[39] = [
                                  _createElementVNode("i", { class: "flaticon-bank" }, null, -1),
                                  _createTextVNode(" Consultar no banco ", -1)
                                ]))], 8, _hoisted_37))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("li", null, [
                            (item.status?.podeProtestar)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "dropdown-item",
                                  href: "javascript:void(0)",
                                  onClick: ($event: any) => (novaOcorrencia(item, '9'))
                                }, [...(_cache[40] || (_cache[40] = [
                                  _createElementVNode("i", { class: "flaticon-dislike" }, null, -1),
                                  _createTextVNode(" Pedido de protesto ", -1)
                                ]))], 8, _hoisted_38))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("li", null, [
                            (item.status?.podeSustarProtesto)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "dropdown-item",
                                  href: "javascript:void(0)",
                                  onClick: ($event: any) => (novaOcorrencia(item, '10'))
                                }, [...(_cache[41] || (_cache[41] = [
                                  _createElementVNode("i", { class: "flaticon-cancel" }, null, -1),
                                  _createTextVNode(" Sustar protesto ", -1)
                                ]))], 8, _hoisted_39))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("li", null, [
                            (item.status?.podeSustarProtesto)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "dropdown-item",
                                  href: "javascript:void(0)",
                                  onClick: ($event: any) => (novaOcorrencia(item, '74'))
                                }, [...(_cache[42] || (_cache[42] = [
                                  _createElementVNode("i", { class: "flaticon-cancel" }, null, -1),
                                  _createTextVNode(" Sustar protesto e Baixar titulo ", -1)
                                ]))], 8, _hoisted_40))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("li", null, [
                            (item.status?.podeSustarProtesto)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "dropdown-item",
                                  href: "javascript:void(0)",
                                  onClick: ($event: any) => (novaOcorrencia(item, '75'))
                                }, [...(_cache[43] || (_cache[43] = [
                                  _createElementVNode("i", { class: "flaticon-cancel" }, null, -1),
                                  _createTextVNode(" Sustar protesto e Manter em carteira ", -1)
                                ]))], 8, _hoisted_41))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ])
                ], 10, _hoisted_13))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("a", {
            class: "btn btn-sm btn-primary",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(controle).janGerarBoletos = true)),
            title: "Gerar boletos"
          }, " Gerar boletos "),
          _createElementVNode("a", {
            class: "btn btn-sm btn-primary",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(controle).janGerarRemessa = !_unref(controle).janGerarRemessa)),
            onGerou: _cache[14] || (_cache[14] = ($event: any) => (pesquisar())),
            title: "Gerar remessa"
          }, [...(_cache[45] || (_cache[45] = [
            _createElementVNode("i", { class: "fa fa-upload" }, null, -1),
            _createTextVNode(" Remessa ", -1)
          ]))], 32),
          _createElementVNode("a", {
            class: "btn btn-sm btn-primary",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_unref(controle).janImportarRetorno = !_unref(controle).janImportarRetorno)),
            onImportou: _cache[16] || (_cache[16] = ($event: any) => (pesquisar())),
            title: "Importar arquivo de retorno do banco"
          }, [...(_cache[46] || (_cache[46] = [
            _createElementVNode("i", { class: "fa fa-download" }, null, -1),
            _createTextVNode(" Retorno ", -1)
          ]))], 32),
          _createElementVNode("a", {
            class: "btn btn-sm btn-primary",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (atualizarPixSelecionados())),
            title: "Consulta os boletos marcados no banco e atualiza o código PIX (útil para boletos registrados via remessa/retorno, que não trazem o PIX)"
          }, [...(_cache[47] || (_cache[47] = [
            _createElementVNode("i", { class: "fa fa-qrcode" }, null, -1),
            _createTextVNode(" Atualizar PIX ", -1)
          ]))]),
          _createVNode(_unref(RouterLink), {
            class: "btn btn-sm btn-primary",
            to: "/boletosRemessas",
            title: "Ver remessas"
          }, {
            default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
              _createTextVNode(" Ver Remessa ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_unref(RouterLink), {
            class: "btn btn-sm btn-primary",
            to: "/boletosRetornos",
            title: "Ver retornos"
          }, {
            default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
              _createTextVNode(" Ver Retorno ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_unref(RouterLink), {
            class: "btn btn-sm btn-primary",
            to: "/boletos/importarRelatorioBanco",
            title: "Importar relatório de títulos (Vencidos/Liquidados/Baixados) exportado do portal do banco"
          }, {
            default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
              _createElementVNode("i", { class: "fa fa-file-excel" }, null, -1),
              _createTextVNode(" Relatório Banco ", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_44, [
            _cache[52] || (_cache[52] = _createElementVNode("button", {
              class: "btn btn-primary btn-sm dropdown-toggle",
              type: "button",
              "data-bs-toggle": "dropdown",
              "aria-expanded": "false",
              title: "Mais opções"
            }, [
              _createElementVNode("i", { class: "fa fa-tools" })
            ], -1)),
            _createElementVNode("ul", _hoisted_45, [
              _createElementVNode("li", null, [
                _createVNode(_unref(RouterLink), {
                  class: "dropdown-item",
                  to: "/boletos/consultarBanco"
                }, {
                  default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                    _createTextVNode("Consultar no banco ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_unref(controle).janColunas = true)),
                  title: "Escolher colunas a exibir"
                }, "Colunas")
              ])
            ])
          ]),
          _createVNode(_unref(RouterLink), {
            class: "btn btn-sm btn-secondary ms-auto",
            to: "/",
            title: "Fechar"
          }, {
            default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
              _createTextVNode(" Fechar ", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, " Boletos: [" + _toDisplayString(_unref(controle).boletos?.length) + "] - R$ " + _toDisplayString(_unref(f2dec)(_unref(controle).totais?.total)) + "  |  Selecionado: [" + _toDisplayString(_unref(controle).boletos.filter(a => a.marcado == true).length) + "] - R$ " + _toDisplayString(_unref(f2dec)(_unref(controle).boletos.filter(a => a.marcado == true).reduce((total, boleto) =>
                        total + (boleto.valorDocumento ?? 0), 0))), 1),
          _createVNode(Paginador, {
            paginaAtual: _unref(controle).filtros.paginaAtual,
            tamanhoPagina: _unref(controle).filtros.tamanhoPagina,
            totalRegistros: _unref(controle).totalRegistros,
            onOnChange: _cache[19] || (_cache[19] = (el) => {
                        _unref(controle).filtros.paginaAtual = el.paginaAtual;
                        _unref(controle).filtros.tamanhoPagina = el.tamanhoPagina;
                        pesquisar()
                    })
          }, null, 8, ["paginaAtual", "tamanhoPagina", "totalRegistros"])
        ])
      ])
    ]),
    _createVNode(MsgBox, {
      id: 'janColunas',
      titulo: 'Colunas',
      exibir: _unref(controle).janColunas,
      onOnFechou: _cache[21] || (_cache[21] = ($event: any) => (_unref(controle).janColunas = false)),
      botaoFechar: true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).colunas, (item, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "form-check",
                key: idx
              }, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: `chkcol-${idx}`,
                  "onUpdate:modelValue": ($event: any) => ((item.exibe) = $event),
                  onChange: _cache[20] || (_cache[20] = ($event: any) => (salvarConfig()))
                }, null, 40, _hoisted_50), [
                  [_vModelCheckbox, item.exibe]
                ]),
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: `chkcol-${idx}`
                }, _toDisplayString(item.coluna), 9, _hoisted_51)
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["exibir"]),
    _createVNode(MsgBox, {
      id: 'janDetalhesBoleto',
      tamanho: "modal-xl",
      titulo: 'Boleto ' + _unref(controle).boletoId,
      exibir: _unref(controle).janDetalhes,
      onOnFechou: _cache[22] || (_cache[22] = ($event: any) => (_unref(controle).janDetalhes = false)),
      botaoFechar: true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_52, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(secoesDetalhes(_unref(controle).boleto), (secao, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-md-6 mb-2",
              key: i
            }, [
              _createElementVNode("div", _hoisted_53, _toDisplayString(secao.titulo), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(secao.campos, (campo, j) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "row small",
                  key: j
                }, [
                  _createElementVNode("div", _hoisted_54, _toDisplayString(campo[0]), 1),
                  _createElementVNode("div", _hoisted_55, _toDisplayString(campo[1]), 1)
                ]))
              }), 128))
            ]))
          }), 128))
        ]),
        _cache[56] || (_cache[56] = _createElementVNode("div", { class: "fw-bold border-bottom mb-1 mt-2" }, "Remessas e retornos", -1)),
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("table", _hoisted_57, [
            _cache[55] || (_cache[55] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "Tipo"),
                _createElementVNode("th", null, "Data"),
                _createElementVNode("th", null, "Nº"),
                _createElementVNode("th", null, "Arquivo"),
                _createElementVNode("th", null, "Ocorrência"),
                _createElementVNode("th", { class: "text-end" }, "Valor pago"),
                _createElementVNode("th", null, "Dt crédito"),
                _createElementVNode("th", null, "Observação")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_unref(controle).historico.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_58, [...(_cache[54] || (_cache[54] = [
                    _createElementVNode("td", {
                      colspan: "8",
                      class: "text-center"
                    }, "Nenhuma remessa ou retorno para este boleto", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).historico, (h, idx) => {
                return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge", h.tipo == 'Remessa' ? 'bg-primary' : 'bg-success'])
                    }, _toDisplayString(h.tipo), 3)
                  ]),
                  _createElementVNode("td", _hoisted_59, _toDisplayString(dataOuTraco(h.data)), 1),
                  _createElementVNode("td", null, _toDisplayString(h.numero), 1),
                  _createElementVNode("td", null, _toDisplayString(h.arquivo ?? '-'), 1),
                  _createElementVNode("td", null, _toDisplayString(h.ocorrenciaId) + _toDisplayString(h.ocorrencia ? ' - ' + h.ocorrencia : ''), 1),
                  _createElementVNode("td", _hoisted_60, _toDisplayString(h.valorPago ? _unref(f2dec)(h.valorPago) : '-'), 1),
                  _createElementVNode("td", _hoisted_61, _toDisplayString(h.tipo == 'Retorno' ? dataOuTraco(h.dataCredito) : '-'), 1),
                  _createElementVNode("td", null, _toDisplayString(h.observacao ?? ''), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("span", null, _toDisplayString(_unref(controle).statusHistorico), 1),
          _createElementVNode("span", _hoisted_63, _toDisplayString(_unref(controle).erroHistorico), 1)
        ])
      ]),
      _: 1
    }, 8, ["titulo", "exibir"]),
    _createVNode(GerarBoletos, {
      onGerou: _cache[23] || (_cache[23] = ($event: any) => (pesquisar())),
      exibir: _unref(controle).janGerarBoletos,
      onFechou: _cache[24] || (_cache[24] = ($event: any) => (_unref(controle).janGerarBoletos = false))
    }, null, 8, ["exibir"]),
    _createVNode(GerarRemessa, {
      boletos: _unref(controle).boletos.filter(a => a.marcado == true),
      exibir: _unref(controle).janGerarRemessa,
      onFechou: _cache[25] || (_cache[25] = ($event: any) => (_unref(controle).janGerarRemessa = false)),
      onGerou: _cache[26] || (_cache[26] = ($event: any) => (pesquisar()))
    }, null, 8, ["boletos", "exibir"]),
    _createVNode(ImportarRetorno, {
      exibir: _unref(controle).janImportarRetorno,
      onFechou: _cache[27] || (_cache[27] = ($event: any) => (_unref(controle).janImportarRetorno = false)),
      onImportou: _cache[28] || (_cache[28] = ($event: any) => (pesquisar()))
    }, null, 8, ["exibir"])
  ], 64))
}
}

})